import { render, staticRenderFns } from "./CustomContainer.vue?vue&type=template&id=99fe03f8&scoped=true"
import script from "./CustomContainer.vue?vue&type=script&lang=ts"
export * from "./CustomContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fe03f8",
  null
  
)

export default component.exports